// Предупреждение над полем промпта: элемент пропал из библиотеки, имя элемента
// столкнулось со словом промпта, не хватает кадра. Поводы разные, вид один —
// поэтому плашка живёт одним компонентом, а не тремя копиями классов подряд.

import type { ReactNode } from "react";

export function PromptNotice({ children }: { children: ReactNode }) {
    return (
        <div
            role="status"
            className="mb-1.5 inline-flex items-center rounded-md bg-amber-500/10 px-2 py-1 text-xs text-amber-200 ring-1 ring-amber-400/30 ring-inset"
        >
            {children}
        </div>
    );
}
